import { gql } from "@apollo/client";

const SUPPORT_TICKET_FIELDS = `
  id
  environmentId
  title
  description
  category
  status
  priority
  isSticky
  dueDate
  createdAt
  updatedAt
  user {
    id
    username
  }
  assignedUser {
    id
    username
  }
  environment {
    id
    name
    host
  }
  comments {
    id
    content
    createdAt
    user {
      id
      username
    }
  }
`;

export const GET_MY_SUPPORT_TICKETS = gql`
  query MySupportTickets {
    mySupportTickets {
      ${SUPPORT_TICKET_FIELDS}
    }
  }
`;

export const GET_SUPPORT_TICKET = gql`
  query SupportTicket($id: Int!) {
    supportTicket(id: $id) {
      ${SUPPORT_TICKET_FIELDS}
    }
  }
`;

export const CREATE_SUPPORT_TICKET = gql`
  mutation CreateSupportTicket($input: CreateSupportTicketInput!) {
    createSupportTicket(input: $input) {
      ${SUPPORT_TICKET_FIELDS}
    }
  }
`;

export const UPDATE_SUPPORT_TICKET = gql`
  mutation UpdateSupportTicket($input: UpdateSupportTicketInput!) {
    updateSupportTicket(input: $input) {
      ${SUPPORT_TICKET_FIELDS}
    }
  }
`;

export const ADD_SUPPORT_TICKET_COMMENT = gql`
  mutation AddSupportTicketComment($input: AddSupportTicketCommentInput!) {
    addSupportTicketComment(input: $input) {
      id
      ticketId
      content
      isSticky
      createdAt
      user {
        id
        username
      }
    }
  }
`;
